import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
  selector: 'textarea-base',
  templateUrl: './base-textarea.component.html',
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BaseTextareaComponent),
    multi: true
  } ]
})
export class BaseTextareaComponent extends BaseInputComponent {

  @Input() rows: number = 3;
  @Input() formGroupClass = 'form-group';

  onChange($event): void {
    this.error = '';
    this.toggleInvalidClass(false);
    if (this.change) {
      this.change.emit($event.target.value);
    }
  }

  onKeyup($event): void {
    this.error = '';
    this.toggleInvalidClass(false);
    if (this.keyupEvent) {
      this.keyupEvent.emit($event);
    }
  }
}
